import { css } from "@emotion/react";

import { dimensions } from "@styles";

export const flex = css`
  flex: 1 0 auto;
`;

export const style = css`
  padding: 2rem 0;

  @media (max-width: ${dimensions.phoneMax}) {
    padding-top: 1rem;
  }
`;
